import { render } from "./HorizontalTimeline.vue?vue&type=template&id=37b97970&scoped=true"
import script from "./HorizontalTimeline.vue?vue&type=script&lang=js"
export * from "./HorizontalTimeline.vue?vue&type=script&lang=js"

import "./HorizontalTimeline.vue?vue&type=style&index=0&id=37b97970&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b97970"]])

export default __exports__